module.exports = __webpack_public_path__ + "media/images/icon-foryourteam-bda87e1137037fe69c10093d16926072.svg";